module.exports = __webpack_public_path__ + "img/photo2_4.b92f763d.jpg";